import './index.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/auth-context';
import { ProtectedRoute } from './components/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import PracticaPage from './pages/PracticaPage';
import OnlinePage from './pages/OnlinePage';
import OnlineGamePage from './pages/OnlineGamePage';
import InfoPage from './pages/InfoPage';
import ClassificacioPage from './pages/ClassificacioPage';

export function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route
            path="/inici"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/practica"
            element={
              <ProtectedRoute>
                <PracticaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/online"
            element={
              <ProtectedRoute>
                <OnlinePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/online/game"
            element={
              <ProtectedRoute>
                <OnlineGamePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/info"
            element={
              <ProtectedRoute>
                <InfoPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/classificacio"
            element={
              <ProtectedRoute>
                <ClassificacioPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
        <Toaster
          position="top-center"
          toastOptions={{
            duration: 3000,
            style: {
              background: '#18181b',
              color: '#fff',
              border: '1px solid #27272a',
            },
            success: {
              iconTheme: {
                primary: '#10b981',
                secondary: '#fff',
              },
            },
            error: {
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fff',
              },
            },
          }}
        />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
